import { LeafletOsmProvider } from './map-provider-osm.js';

document.addEventListener('DOMContentLoaded', () => {
    const mapEl = document.getElementById('chipmap-map');
    if (!mapEl) {
        return;
    }

    const locations = JSON.parse(mapEl.dataset.locations || '[]');
    const actorTypes = JSON.parse(mapEl.dataset.actorTypes || '[]');
    const actorTypeByKey = new Map(actorTypes.map((actorType) => [actorType.key, actorType]));

    // Provider-Wahl ueber data-provider (aus plugin.tx_chipmap_standort.settings.mapProvider) -
    // Filter-/Suchlogik unten kennt nur MapProvider#addMarker/#showMarker/#removeMarker/#fitToMarkers, siehe
    // map-provider-interface.js. Google-Adapter kann spaeter ergaenzt werden, ohne diese Datei zu aendern.
    const provider = mapEl.dataset.provider === 'google' ? null : new LeafletOsmProvider();
    if (!provider) {
        console.warn(`Chip Mäp: Kartenanbieter "${mapEl.dataset.provider}" ist noch nicht implementiert.`);
        return;
    }

    provider.init(mapEl, {
        tileUrl: mapEl.dataset.tileUrl,
        attribution: mapEl.dataset.attribution,
        centerLat: parseFloat(mapEl.dataset.centerLat),
        centerLng: parseFloat(mapEl.dataset.centerLng),
        zoom: parseInt(mapEl.dataset.zoom, 10),
        cluster: mapEl.dataset.cluster === '1',
    });

    if (mapEl.dataset.regionOutlineUrl) {
        provider.addGeoJsonOverlay(mapEl.dataset.regionOutlineUrl, {
            color: mapEl.dataset.regionOutlineColor || '#2A2623',
            weight: 3,
        });
    }

    const labelDetails = mapEl.dataset.labelDetails || 'Details';

    // Beim initialen Laden bewusst NICHT auf die Marker-Bounds zoomen (siehe applyFilter() weiter
    // unten fuer das Verhalten beim Filtern) - die Karte soll immer mit der konfigurierten
    // Baden-Wuerttemberg-Ansicht (mapDefaultLat/-Lng/-Zoom) starten, unabhaengig davon, wie viele/
    // wo die aktuell gepflegten Standorte liegen.
    const markersByUid = new Map();
    locations.forEach((location) => {
        const actorType = actorTypeByKey.get(location.actorType);
        const marker = provider.addMarker({
            ...location,
            iconUrl: '',
            color: actorType ? actorType.color : '#2A2623',
            popupHtml: `<strong>${escapeHtml(location.name)}</strong><br>${escapeHtml(location.city)}<br><a href="${location.detailUrl}">${escapeHtml(labelDetails)}</a>`,
        });
        if (marker) {
            markersByUid.set(location.uid, marker);
        }
    });

    const searchInput = document.getElementById('chipmap-search');
    const resetButton = document.getElementById('chipmap-filter-reset');
    const cardElements = Array.from(document.querySelectorAll('#chipmap-list .cc-chipmap__card'));
    const cardsSentinel = document.getElementById('chipmap-list-sentinel');
    const loadMoreButton = document.getElementById('chipmap-load-more');
    const statusRegion = document.getElementById('chipmap-status');
    const statusTemplate = mapEl.dataset.statusTemplate || '{count} / {total}';

    // Standorte ohne gepflegte Koordinaten (siehe StandortController::listAction() - werden dort
    // bewusst nicht in "locations" aufgenommen) nehmen an Filterung/Pagination der Kacheln nicht
    // teil und bleiben unangetastet sichtbar - bestehendes Verhalten, hier nur als Set fuer
    // schnelles Nachschlagen in renderCards().
    const locationUids = new Set(locations.map((location) => location.uid));

    // Infinite Scroll: Kacheln werden in Schritten von 12 nachgeladen, sobald der unsichtbare
    // Sentinel am Listenende in den Viewport scrollt. matchingLocations wird bei jeder Filter-/
    // Suchaenderung in applyFilter() neu gesetzt (Reihenfolge = Reihenfolge von "locations",
    // identisch zur Server-Renderreihenfolge der Karten).
    const cardsPageSize = 12;
    // Kleine kuenstliche Verzoegerung, damit das Nachladen ueberhaupt wahrnehmbar ist - da es rein
    // clientseitig aus bereits geladenen Daten passiert (kein Request), waere es sonst instantan
    // und liesse sich beim Scrollen kaum von "war schon immer da" unterscheiden (siehe Chat).
    const cardsLoadDelayMs = 300;
    let cardsVisibleCount = cardsPageSize;
    let matchingLocations = locations;
    let isLoadingMoreCards = false;

    // announce=false unterdrueckt die Screenreader-Statusansage (siehe unten) - genutzt beim
    // allerersten Rendern, damit nicht direkt nach dem Laden der Seite unaufgefordert "12 von 33
    // Standorten angezeigt" vorgelesen wird (kein "Wechsel", sondern der Ausgangszustand).
    function renderCards(announce = true) {
        const visibleUids = new Set(matchingLocations.slice(0, cardsVisibleCount).map((location) => location.uid));
        cardElements.forEach((cardElement) => {
            const uid = parseInt(cardElement.dataset.uid, 10);
            if (!locationUids.has(uid)) {
                return;
            }
            cardElement.style.display = visibleUids.has(uid) ? '' : 'none';
        });

        const hasMore = cardsVisibleCount < matchingLocations.length;
        if (cardsSentinel) {
            cardsSentinel.style.display = hasMore ? '' : 'none';
        }
        if (loadMoreButton) {
            loadMoreButton.style.display = hasMore ? '' : 'none';
        }

        // WCAG 4.1.3 (Status Messages): Trefferzahl-/Ladeaenderungen sind sonst rein visuell und
        // wuerden Screenreader-Nutzern ohne diese Ansage komplett entgehen (siehe Chat).
        if (announce && statusRegion) {
            const shown = Math.min(cardsVisibleCount, matchingLocations.length);
            statusRegion.textContent = statusTemplate
                .replace('{count}', String(shown))
                .replace('{total}', String(matchingLocations.length));
        }
    }

    function loadMoreCards() {
        if (cardsVisibleCount >= matchingLocations.length) {
            return;
        }
        cardsVisibleCount += cardsPageSize;
        renderCards();
    }

    // IntersectionObserver statt Scroll-Event-Listener: kein Throttling/Debouncing noetig, feuert
    // von sich aus nur, wenn der Sentinel tatsaechlich in Sichtweite kommt. In allen aktuell
    // relevanten Browsern verfuegbar, daher kein Scroll-Event-Fallback.
    //
    // rootMargin bewusst 0 (kein Vorlade-Puffer): Da das Nachladen rein clientseitig aus bereits
    // geladenen Daten passiert (kein Request, keine spuerbare Ladezeit), wuerde ein Puffer wie
    // z.B. 200px bei ausreichend hohem Viewport dazu fuehren, dass die naechsten 12 Kacheln schon
    // NACHLADEN, bevor ueberhaupt merklich gescrollt wurde - bei kleinen Ergebnismengen kaskadiert
    // das dann bis alles auf einmal da ist (siehe Chat). Ohne Puffer laedt erst nach, wenn der
    // Sentinel tatsaechlich am unteren Viewport-Rand ankommt.
    if (cardsSentinel && 'IntersectionObserver' in window) {
        const sentinelObserver = new IntersectionObserver((entries) => {
            // isLoadingMoreCards verhindert, dass waehrend der kuenstlichen Verzoegerung (s.o.)
            // ein zweiter, sich ueberlappender Ladevorgang angestossen wird, falls der Observer
            // (z.B. durch einen Layout-Sprung) nochmal feuert, bevor renderCards() den Sentinel
            // aus dem Viewport herausgeschoben hat.
            if (entries[0].isIntersecting && !isLoadingMoreCards && cardsVisibleCount < matchingLocations.length) {
                isLoadingMoreCards = true;
                window.setTimeout(() => {
                    loadMoreCards();
                    isLoadingMoreCards = false;
                }, cardsLoadDelayMs);
            }
        }, { rootMargin: '0px' });
        sentinelObserver.observe(cardsSentinel);
    }

    // Tastatur-/Screenreader-Fallback (siehe List.html-Kommentar beim Button): kein rootMargin-
    // Zoegern noetig, da es hier ein expliziter Klick ist, keine automatische Vorhersage.
    loadMoreButton?.addEventListener('click', loadMoreCards);

    // Dropdown-mit-Checkboxen statt einer nativen <select>-Listbox (die sah als permanent
    // aufgeklapptes Listenfeld unpassend aus, und <option> laesst sich browseruebergreifend nicht
    // zuverlaessig einfaerben) - <details>/<summary> liefert Fokus/Tastatur-Toggle kostenlos vom
    // Browser, die Zusammenfassung im Summary-Text ersetzt die fehlende native Auswahl-Anzeige.
    // Alle drei Filtergruppen (Akteurstyp, Funktion im Oekosystem, Halbleiterkompetenzen) sind
    // Mehrfachauswahl (Checkboxen), obwohl ein einzelner Standort z.B. nur EINEN Akteurstyp haben
    // kann (siehe Standort::$actorType) - die Mehrfachauswahl im Filter fragt trotzdem sinnvoll
    // "zeig mir Start-ups ODER KMU" ab, unabhaengig davon, wie viele Werte ein einzelner Standort
    // selbst tragen kann (siehe locationMatchesGroup() unten). Im Registrierungsformular
    // (StandortSelfService/New.html) bleibt Akteurstyp bewusst ein normales <select> (Einfachauswahl) -
    // das betrifft nur die Dateneingabe, nicht diesen Listen-Filter hier.
    const multiselects = Array.from(document.querySelectorAll('.cc-chipmap__multiselect')).map((detailsEl) => {
        const inputs = Array.from(detailsEl.querySelectorAll('input[type="checkbox"]'));
        const summaryText = detailsEl.querySelector('.cc-chipmap__multiselect-summary-text');
        const summarySwatch = detailsEl.querySelector('.cc-chipmap__multiselect-summary-swatch');
        const placeholder = detailsEl.dataset.placeholder || '';
        const selectedSuffix = detailsEl.dataset.selectedSuffix || '';

        function updateSummary() {
            const checked = inputs.filter((input) => input.checked);
            if (summaryText) {
                summaryText.textContent = checked.length === 0
                    ? placeholder
                    : `${checked.length} ${selectedSuffix}`;
            }
            if (summarySwatch) {
                const color = checked.length === 1 ? checked[0].dataset.color : null;
                summarySwatch.style.backgroundColor = color || '';
                summarySwatch.classList.toggle('is-visible', Boolean(color));
            }
        }

        function getValues() {
            return inputs.filter((input) => input.checked).map((input) => input.value);
        }

        function reset() {
            inputs.forEach((input) => {
                input.checked = false;
            });
            updateSummary();
        }

        inputs.forEach((input) => input.addEventListener('change', () => {
            updateSummary();
            applyFilter();
        }));

        return { detailsEl, filterGroup: detailsEl.dataset.filterGroup, inputs, getValues, reset };
    });

    // Nur ein Dropdown gleichzeitig offen, Klick ausserhalb schliesst - klassisches Dropdown-Verhalten,
    // <details> bietet das nicht von Haus aus.
    multiselects.forEach(({ detailsEl }) => {
        detailsEl.addEventListener('toggle', () => {
            if (detailsEl.open) {
                multiselects.forEach(({ detailsEl: other }) => {
                    if (other !== detailsEl) {
                        other.open = false;
                    }
                });
            }
        });
    });
    document.addEventListener('click', (event) => {
        multiselects.forEach(({ detailsEl }) => {
            if (detailsEl.open && !detailsEl.contains(event.target)) {
                detailsEl.open = false;
            }
        });
    });

    function getMultiselectValues(filterGroup) {
        return multiselects.find((entry) => entry.filterGroup === filterGroup)?.getValues() || [];
    }

    function getSelections() {
        return {
            actorType: getMultiselectValues('actorType'),
            ecosystemFunction: getMultiselectValues('ecosystemFunction'),
            semiconductorCompetence: getMultiselectValues('semiconductorCompetence'),
        };
    }

    function locationMatchesSelections(location, selections, searchTerm) {
        return Object.keys(selections).every((groupKey) => locationMatchesGroup(location, groupKey, selections[groupKey]))
            && (searchTerm === '' || `${location.name} ${location.city}`.toLowerCase().includes(searchTerm));
    }

    // Alle drei Filtergruppen (Akteurstyp, Funktion im Oekosystem, Halbleiterkompetenzen) und die
    // Suche werden per UND verknuepft; innerhalb einer Mehrfachauswahl-Box genuegt EIN Treffer (ODER).
    function applyFilter() {
        const selections = getSelections();
        const searchTerm = (searchInput?.value || '').trim().toLowerCase();
        const visibleMarkers = [];
        const matches = [];

        locations.forEach((location) => {
            const visible = locationMatchesSelections(location, selections, searchTerm);

            // Absichtlich showMarker()/removeMarker() statt CSS-display:none: bei aktiviertem
            // Clustering (siehe data-cluster) berechnet Leaflet.markercluster die Zahlen-Bubbles aus
            // der tatsaechlichen Layer-Zugehoerigkeit, nicht aus der CSS-Sichtbarkeit einzelner
            // Marker-DOM-Elemente - ausgefilterte Marker muessen also wirklich aus der Cluster-Gruppe
            // entfernt werden, sonst zaehlen sie beim Zoomen/Spiderfy weiter mit.
            const marker = markersByUid.get(location.uid);
            if (marker) {
                if (visible) {
                    provider.showMarker(marker);
                } else {
                    provider.removeMarker(marker);
                }
            }
            if (visible) {
                matches.push(location);
                if (marker) {
                    visibleMarkers.push(marker);
                }
            }
        });

        // Karte zoomt/zentriert nach jeder Filteraenderung neu auf die sichtbare Teilmenge (ALLE
        // Treffer, nicht nur die aktuell per Infinite Scroll geladenen Kacheln) - damit sie bei
        // starker Filterung nicht auf dem urspruenglichen Gesamt-Ausschnitt "leer" wirkt.
        provider.fitToMarkers(visibleMarkers);
        updateAvailability(selections, searchTerm);

        // Die Trefferzahl wird nur sichtbar, wenn tatsaechlich gefiltert/gesucht wird - ohne
        // aktive Filter aendert sie sich sonst beim reinen Scrollen (Infinite Scroll) unbemerkt im
        // Hintergrund, was eher irritiert als hilft (siehe Chat). Die Screenreader-Ansage selbst
        // (siehe renderCards()) bleibt davon unberuehrt, nur die visuelle Sichtbarkeit haengt dran.
        const hasActiveFilters = searchTerm !== '' || Object.values(selections).some((values) => values.length > 0);
        statusRegion?.classList.toggle('is-visible', hasActiveFilters);

        // Filter-/Suchaenderung faengt die Kachel-Pagination wieder bei den ersten 12 Treffern an.
        matchingLocations = matches;
        cardsVisibleCount = cardsPageSize;
        renderCards();
    }

    // Dynamisches Ausgrauen: Eine noch NICHT ausgewaehlte Option wird deaktiviert, sobald sie -
    // zusaetzlich zu den AKTIVEN FILTERN DER ANDEREN GRUPPEN/der Suche - keinen einzigen Standort
    // mehr treffen wuerde. Bereits ausgewaehlte Optionen und "Alle" (value="") bleiben immer
    // klickbar, damit man jederzeit wieder abwaehlen kann.
    //
    // WICHTIG: Die zu pruefende Option wird bewusst ISOLIERT getestet (nur sie selbst in ihrer
    // eigenen Gruppe), NICHT vereinigt mit bereits angehakten Geschwister-Optionen derselben
    // Gruppe - sonst waere jede weitere Option automatisch "verfuegbar", sobald irgendeine andere
    // Option in derselben Gruppe schon (per ODER) mindestens einen Treffer liefert, was saemtliche
    // Ausgrauung in dem Moment aufheben wuerde, in dem man eine noch verfuegbare Option anhakt
    // (siehe Chat: Bug "Systemintegrator" + Kompetenz anhaken hob alle anderen ausgegrauten
    // Kompetenzen wieder auf). Nur die Filter der JEWEILS ANDEREN Gruppen fliessen unveraendert
    // (mit ihrer tatsaechlichen Auswahl) mit ein. Kosten: Anzahl-Optionen * Anzahl-Standorte
    // einfache Vergleiche bei jeder Filteraenderung - bei den hier ueblichen Standort-Mengen
    // vernachlaessigbar.
    function updateAvailability(selections, searchTerm) {
        multiselects.forEach(({ inputs, filterGroup }) => {
            inputs.forEach((input) => {
                if (input.value === '' || input.checked) {
                    input.disabled = false;
                    input.closest('.cc-chipmap__multiselect-option')?.classList.remove('is-unavailable');
                    return;
                }

                const hypotheticalSelections = { ...selections, [filterGroup]: [input.value] };
                const available = locations.some((location) => locationMatchesSelections(location, hypotheticalSelections, searchTerm));

                input.disabled = !available;
                input.closest('.cc-chipmap__multiselect-option')?.classList.toggle('is-unavailable', !available);
            });
        });
    }

    searchInput?.addEventListener('input', applyFilter);
    resetButton?.addEventListener('click', () => {
        multiselects.forEach(({ reset }) => reset());
        if (searchInput) {
            searchInput.value = '';
        }
        applyFilter();
    });

    // Einmalig beim Laden pruefen, ob es bereits Optionen ohne jeden Standort im Datensatz gibt
    // (z.B. eine Kategorie ohne zugeordnete Standorte), und die Kacheln auf die ersten 12 Treffer
    // beschneiden - bewusst ueber updateAvailability()/renderCards() statt applyFilter(), damit der
    // initiale Kartenausschnitt (siehe Kommentar oben) unangetastet bleibt.
    updateAvailability(getSelections(), '');
    renderCards(false);
});

function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value ?? '';
    return div.innerHTML;
}

// groupKey entspricht 1:1 dem jeweiligen data-filter-group/Location-Feldnamen ('actorType' ist ein
// einzelner Wert, 'ecosystemFunction'/'semiconductorCompetence' sind Arrays von Kategorie-Keys).
function locationMatchesGroup(location, groupKey, values) {
    if (values.length === 0) {
        return true;
    }
    if (groupKey === 'actorType') {
        return values.includes(location.actorType);
    }
    return location[groupKey].some((key) => values.includes(key));
}
